import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealRecommendBuilding";


export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}


export function checkRecommend(dealId) {
  console.log("id:", dealId)
  return axios({
    url: `/ws/${moduleName}/checkRecommend/${dealId}`,
    method: 'get',
  })
}



export default {
  selectAll,
  insert,
  update,
  checkRecommend
}


